module.directive('pager', function() {
  return {
    restrict: 'E',
    templateUrl: 'util/widgets/pager',
    require: '?ngModel',
    scope: {
      page:  '=?',
      pages: '=?',
      total: '=?',
    },

    link: function(scope, element, attrs, ngModelControler) {
      scope.offset = 1;
      scope.limit = 10;
      scope.before = Math.floor(scope.limit / 3);

      scope.$watch("pages", function(pages) {
        pages = pages || 0;

        if (scope.limit) {
          pages = Math.min(pages, scope.limit);
        }
        scope.pageArray = new Array(pages);
      });

      scope.$watch("page", function() {
        var page = parseInt(scope.page);
        // Reset the page offset
        if (scope.limit) {
          var pad_l = scope.before,
              pad_r = scope.limit - pad_l;

          if (page - pad_l <= 0 || scope.pages < scope.limit) {
            scope.offset = 1;
          }
          else if (page + pad_r > scope.pages) {
            scope.offset = scope.pages - scope.limit + 1;
          } else {
            scope.offset = page - pad_l;
          }
        } else {
          scope.offset = 1;
        }
      });

      if (ngModelControler) {
        ngModelControler.$render = function() {
          scope.page = ngModelControler.$viewValue || ngModelControler.$modelValue;
        }
      }

      scope.select = function(page) {
        if (page >= 1 && page <= scope.pages) {
          scope.page = page;
          if (ngModelControler) {
            ngModelControler.$setViewValue(page);
          }
        }
      };
    },
  };
});
